var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPintrest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 740 740",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h740v740H0V0Z",
    fill: "#EBEBEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M366.067 92.815c2.964-.002 5.928-.02 8.892-.04 16.168-.049 31.788 1.306 47.666 4.412l3.311.648c17.9 3.634 34.998 9.087 51.797 16.222 1.536.639 3.082 1.254 4.635 1.849 6.843 2.618 13.207 5.896 19.632 9.406l3.078 1.647c6.644 3.607 12.8 7.617 18.922 12.041 2.041 1.376 4.083 2.75 6.125 4.125 17.182 11.823 32.729 26.016 46.938 41.25l1.536 1.64C582 189.749 582 189.749 582 192h2c1.664 2.02 1.664 2.02 3.625 4.812l2.168 3.063L592 203a3747.45 3747.45 0 0 0 3.938 5.312c4.639 6.386 8.887 12.993 13.062 19.688l1.738 2.75C620.517 246.807 627.97 264.232 634 282l.97 2.75c2.576 7.429 4.467 14.874 6.093 22.562.242 1.09.485 2.178.736 3.3 3.963 18.511 5.692 36.888 5.537 55.807-.024 3.108-.02 6.215-.014 9.323-.015 10.95-.555 21.437-2.322 32.258-.199 1.594-.39 3.189-.57 4.785-1.801 14.375-5.682 28.144-9.563 42.065A376.037 376.037 0 0 0 632 466h-2l-.445 1.695c-4.247 15.182-11.792 28.6-19.435 42.28A109.265 109.265 0 0 0 608 514h-2l-.347 1.751c-.71 2.444-1.685 4.113-3.094 6.226l-1.509 2.27-1.612 2.378-1.635 2.434c-3.571 5.268-7.286 10.312-11.377 15.191-1.493 1.702-1.493 1.702-2.426 3.75h-2l-.798 1.772c-1.256 2.328-2.616 3.957-4.432 5.873l-1.936 2.052-2.021 2.115-1.963 2.08c-12.622 13.33-12.622 13.33-18.85 18.108h-2v2h-2v2c-1.736 1.465-3.542 2.846-5.375 4.187l-1.66 1.22A773.321 773.321 0 0 1 536 593l-2.531 1.832C517.565 606.15 500.907 616.191 483 624c-1.35.62-2.698 1.242-4.047 1.863C458.965 634.88 437.546 640.23 416 644l-3.434.645c-14.434 2.609-29.007 2.631-43.628 2.667l-3.084.008c-16.645.005-32.503-1.016-48.854-4.32l-2.73-.534c-8.547-1.695-16.992-3.72-25.27-6.466.647-3.207 1.793-5.64 3.441-8.457l1.508-2.6 1.614-2.756a4024.66 4024.66 0 0 0 3.292-5.71l1.63-2.831c5.509-9.624 10.51-19.34 14.682-29.632.65-1.57 1.321-3.13 2.002-4.686 3.033-7.02 5.311-13.988 7.206-21.39l.886-3.375c.923-3.518 1.832-7.04 2.739-10.563l1.793-6.918c.88-3.398 1.76-6.796 2.636-10.195C335.182 516.23 338.068 505.61 341 495c3.805 4.744 3.805 4.744 5.352 6.773C356.384 514.39 374.254 522.707 390 525c24.717 1.283 46.353-.559 69-11l3.61-1.586c12.734-5.906 23.655-14.363 33.39-24.414l2.438-2.375C520.614 462.907 534.748 434.807 542 404l.895-3.746C548.485 374.67 550 345.597 544 320l-.773-3.676c-4.362-18.629-13.157-36.637-24.332-52.088C516 260.203 516 260.203 516 258h-2a83.837 83.837 0 0 1-3.687-4.563C496.4 235.686 476.979 223.012 457 213l-1.896-1.004c-4.919-2.567-9.863-4.388-15.166-5.996l-2.529-.775c-1.686-.512-3.374-1.02-5.064-1.524-2.04-.61-4.074-1.238-6.107-1.869-30.75-8.987-65.082-8.034-96.238-1.832l-2.34.453c-39.57 7.932-79.184 31.38-102.101 65.063-2.274 3.443-4.418 6.957-6.559 10.484l-1.832 2.848c-6.61 10.61-11.85 22.878-14.66 35.087-.58 2.357-1.299 4.652-2.028 6.967-10.16 33.553-4.902 70.71 9.52 102.098l1.293 2.902c8.098 17.262 21.684 35.39 39.707 43.098 3.759.272 3.759.272 7 0 2.234-4.902 3.83-9.638 5.063-14.875l.512-2.131c.479-1.997.952-3.996 1.425-5.994l.7-2.723A80.306 80.306 0 0 0 267 437l.363-2.188c.546-6.158-1.71-9.188-5.36-13.972-5.61-7.952-9.048-17.257-11.815-26.528l-.59-1.974c-8.26-29.421-3.99-60.658 10.535-87.334C264.649 297.035 269.845 289.8 276 283l2.672-2.957c16.65-17.8 37.95-28.165 61.328-34.043l2.236-.598c7.365-1.75 14.752-1.706 22.276-1.663 2.22.01 4.44 0 6.66-.012 9.104-.01 17.839.694 26.828 2.273l2.217.362C419.013 249.646 436.981 259.24 451 272l2.527 2.27c18.325 17.384 27.38 39.282 31.473 63.73l.57 2.773c4.93 37.021-4.833 80.936-27.586 110.743L456 454l-1.86 2.36C443.822 468.725 427.28 479.868 411 482c-3.522.238-7.033.333-10.562.375l-2.651.043c-12.241-.091-21.463-4.44-30.474-12.543-8.474-8.868-10.639-19.563-10.532-31.396.355-5.635 1.706-10.869 3.219-16.292l.947-3.53c2.385-8.709 5.183-17.245 8.128-25.778 2.438-7.156 4.477-14.355 6.3-21.692l.723-2.908c2.24-9.279 4.26-18.385 4.152-27.967l.023-2.103c-.035-9.518-2.81-18.883-8.992-26.26-8.252-7.897-17.679-9.556-28.716-9.42-12.65.502-21.242 6.694-29.752 15.721-14.74 17.319-17.155 39.856-15.813 61.75.9 8.72 3.03 17.03 6.328 25.156 1.63 6.895-1.064 14.583-2.64 21.344l-.683 2.963a853.265 853.265 0 0 1-4.357 17.912c-2 7.914-3.816 15.871-5.66 23.823a3164.186 3164.186 0 0 1-5.418 22.958c-5.71 23.761-5.71 23.761-11.18 47.579-.434 1.932-.878 3.862-1.322 5.792-2.698 12.22-3.263 24.366-3.255 36.848l-.002 3.337c.061 9.811.799 19.509 1.752 29.268.386 4.034.527 7.97.437 12.02-26.657-6.288-51.88-24.18-73-41l-2.832-2.242C179.388 573.07 163.474 558.81 152 542v-2h-2c-1.202-1.354-1.202-1.354-2.54-3.262l-1.495-2.12c-.525-.76-1.05-1.521-1.59-2.306l-1.645-2.366c-4.49-6.507-8.787-13.091-12.73-19.946l-1.375-2.378c-9.003-15.69-16.308-31.648-21.738-48.919-.693-2.112-1.481-4.193-2.305-6.258-2.066-5.469-3.296-11.126-4.582-16.82l-.792-3.481c-4.758-21.252-6.438-41.78-6.458-63.519l-.005-2.946c-.002-14.026.482-27.674 2.883-41.526.33-1.912.607-3.833.876-5.755.933-6.51 2.613-12.705 4.488-19.003 1.152-3.88 2.186-7.783 3.2-11.7 1.09-3.634 2.44-7.158 3.808-10.695l.863-2.241C113.987 261.545 119.609 248.653 126 236h2l.34-1.672c.774-2.729 1.928-5.056 3.223-7.578l1.378-2.703L134 222h2l.719-2.094c1.525-3.46 3.559-6.373 5.781-9.406l1.322-1.823A936.5 936.5 0 0 1 148 203l1.414-1.917a763.577 763.577 0 0 1 4.086-5.458l1.275-1.713c1.027-1.342 2.12-2.633 3.225-3.912h2l.648-1.61c1.867-3.3 4.39-5.9 6.977-8.64l1.636-1.749C183.367 162.983 183.367 162.983 190 158h2v-2c1.474-1.338 1.474-1.338 3.559-2.871l2.334-1.725 2.545-1.842 2.595-1.892C214.57 139.33 226.376 131.592 239 125c1.25-.69 2.499-1.383 3.746-2.078C265.96 110.112 291.776 101.016 318 97a6534.63 6534.63 0 0 1 9.313-1.625l2.136-.374c12.19-2.044 24.288-2.187 36.618-2.186Z",
    fill: "#E70124"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m374 194.688 2.304.005c19.894.08 38.628 2.553 57.696 8.307l2.013.585C464.328 211.876 496.71 231.48 514 256v2h2a101.39 101.39 0 0 1 4.563 6.438l1.34 2.041c27.291 42.281 31.394 90.017 20.972 138.584C537.333 428.818 527.274 451.868 512 471l-2.059 2.633A513.681 513.681 0 0 1 504 481l-1.555 1.934c-3.741 4.54-7.939 8.298-12.445 12.066l-2.43 2.125C471.754 510.642 453.248 519.484 433 524l-2.093.537c-7.33 1.727-14.616 1.801-22.101 1.779-2.17-.003-4.34.02-6.51.045-19.688.09-37.91-6.534-52.726-19.74-2.862-2.954-5.21-6.263-7.57-9.621-2.4 6.953-4.419 13.956-6.313 21.063l-.921 3.431c-2.036 7.627-3.954 15.276-5.829 22.943-1.82 7.4-3.783 14.727-6.062 22l-.696 2.239c-1.473 4.573-3.267 8.92-5.26 13.29-1.101 2.438-2.07 4.918-3.044 7.409-5.063 12.186-11.676 23.738-18.313 35.125l-1.25 2.157c-3.557 6.01-3.557 6.01-6.312 8.343-3.895-.316-7.26-1.753-11-3v15l-29 1-1 30h-31v-30h-31v-31h31v30h30v-28c10.089 3.363 10.089 3.363 14.75 5.563A180.118 180.118 0 0 0 271 629l-.275-2.433c-2.022-18.224-3.436-36.203-2.725-54.567l.117-3.275c.488-9.33 2.27-18.163 4.383-27.225.359-1.573.717-3.146 1.074-4.72 1.125-4.93 2.273-9.856 3.426-14.78l.56-2.395a5927.173 5927.173 0 0 1 6.695-28.293 7550.68 7550.68 0 0 0 4.245-17.875l.622-2.63a70667.952 70667.952 0 0 0 4.509-19.077c.781-3.3 1.58-6.594 2.406-9.883 1.235-4.936 2.387-9.888 3.526-14.847.22-.946.442-1.892.67-2.867A375.17 375.17 0 0 0 302 416c.15-.725.3-1.45.456-2.196.852-5.012-.055-8.887-1.769-13.554a602.611 602.611 0 0 1-1.406-4.254l-.68-2.079c-6.337-20.2-3.84-45.317 5.38-64.249 6.865-13.05 18.046-23.01 32.019-27.668 12.598-.781 23.512-.686 33.813 7.5 8.586 8.232 11.263 18.34 11.562 29.875.139 21.04-7.423 42.021-14.135 61.733-2.623 7.819-4.714 15.766-6.704 23.766a218.541 218.541 0 0 1-1.111 4.229c-3.286 12.228-1.716 23.459 4.106 34.51 4.987 8.104 13.135 13.728 22.149 16.532C398.113 483 412.347 482.039 424 477l3.137-1.355C436 471.495 443.267 466.086 450 459l1.504-1.3c9.952-8.937 16.547-22.506 21.496-34.7l1.52-3.672c13.377-34.033 16.18-77.77 1.434-111.737-4.033-8.534-8.69-16.496-14.954-23.591l-2.047-2.441c-19.35-22.473-46.02-33.43-74.953-36.559-5.524-.333-11.03-.44-16.563-.438l-2.247-.003c-12.636.026-24.148 1.41-36.19 5.441l-2.19.697c-30.678 9.88-54.11 31.857-68.789 60.236-13.425 27.184-14.939 58.66-5.666 87.399 3.156 9.167 7.098 19.936 13.856 26.969 3.212 4.846 2.17 9.637 1.165 15.076a316.707 316.707 0 0 1-2.202 9.472 512.86 512.86 0 0 0-1.422 5.93c-2.695 11.047-2.695 11.047-5.752 14.221-5.854 1.195-9.604-1.014-14.383-4.094-4.53-3.299-8.571-7.039-12.617-10.906l-1.832-1.605c-21.635-19.71-32.792-55.714-34.31-84.039-.703-17.61-.301-36.933 6.43-53.478.735-1.938 1.242-3.842 1.716-5.858 8.84-37.162 37.218-68.473 68.874-88.19A191.459 191.459 0 0 1 297 209l2-.855c13.9-5.852 28.14-8.806 43-11.145l3.537-.569c9.533-1.414 18.85-1.792 28.463-1.744Z",
    fill: "#FDFDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M62 339h30c.622 6.84 1.161 13.495 1.281 20.332l.056 2.543c.058 2.646.111 5.291.163 7.938.333 22.325.333 22.325 3.188 44.437l.52 2.765c4.28 23.43 4.28 23.43 12.007 45.86L110 465l-1 2-1-4-14 1-.184 6.309-.188 6.026c-.044 1.4-.085 2.8-.125 4.2-.058 2.008-.122 4.016-.187 6.024l-.11 3.665C93 493 93 493 92 494c-2.219.088-4.44.107-6.66.098l-3.684-.008-4.719-.027L62 494v30l30 1v30H62v31h30v30c-13.875.438-13.875.438-18.25.568l-3.43.116-3.523.11c-2.75.024-2.75.024-4.797 1.206v30h30v30H61v-30H31v-31H0V401h31l1 30h29c-.04-8.002-.04-8.002-.09-16.005l-.008-3.038-.016-3.094C61 406 61 406 62 401h30v-31H62v-31Z",
    fill: "#E9EAEA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M555 586h31v31h31v31h-31v30h31v31h31v31h-93v-31h-31v-31h31v-30c-9.828.04-9.828.04-19.656.09l-3.684.008-3.793.016C525 648 525 648 524 647a152.47 152.47 0 0 1-.098-6.66l.005-2.014c.005-2.13.018-4.259.03-6.389A3970.039 3970.039 0 0 1 524 617l-2.08.033c-3.098.041-6.196.067-9.295.093l-3.273.05-3.125.02-2.889.032C501 617 501 617 499 615l1.541-.839c2.343-1.278 4.682-2.563 7.022-3.848l2.423-1.319c4.929-2.715 9.5-5.632 14.014-8.994l2 1-1 1-1 14 31 1v-31Z",
    fill: "#DCDDDD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216 93h31v29l-10 5c-13.861 7.382-26.77 16.183-39.016 26.003C194.206 156 194.206 156 192 156v2c-1.495 1.306-3.05 2.543-4.625 3.75-9.718 7.784-18.944 16.572-26.14 26.773L160 190h-2l-.81 1.751c-1.223 2.312-2.6 4.188-4.237 6.226l-1.804 2.27-1.899 2.378c-4.546 5.743-8.788 11.342-12.234 17.82L136 222h-2l-.34 2.2c-.69 2.926-1.715 5.023-3.222 7.613l-1.38 2.394L128 236h-2l-.313 1.563c-.916 3.25-2.357 6.333-3.687 9.437H93v-31h30v-31H93v-31h30c-.04-8.002-.04-8.002-.09-16.005l-.008-3.038-.016-3.094C123 129 123 129 124 124h30v30h31v-31h31V93Z",
    fill: "#E7E7E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M120 491c2.167 2.762 3.908 5.53 5.531 8.64l1.442 2.724 1.527 2.886c5.772 10.756 12.037 21.115 19.813 30.559C150 538 150 538 150 540h2c1.099 1.437 2.126 2.93 3.125 4.438C165.694 559.388 179.693 572.673 194 584l2.144 1.705c2.364 1.876 4.734 3.743 7.106 5.607l2.292 1.815c4.323 3.375 8.622 6.282 13.458 8.873l-2 2-1 12h-31v-30h-31v30h-30l-1-30H93v-30c3.648-.912 6.357-1.116 10.078-1.098l3.17.008 4.002.028L123 555v-31H93v-30l27-1v-2Z",
    fill: "#F6F7F6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M493 0h93v31h-31l1 30 30 1 .063 13.313.027 4.188.008 3.3.016 3.38C586 89 586 89 585 92h-30V62c-9.828.04-9.828.04-19.656.09l-3.684.008-3.793.016C525 62 525 62 524 61a152.47 152.47 0 0 1-.098-6.66l.008-3.684.028-4.718L524 31h-31V0ZM31 339h31v31h30v31H62l-1 30-30 1v-31H0v-31h31v-31ZM0 494h31v30h30v31H31v31H0v-92Z",
    fill: "#F6F6F6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 93h31v30c9.499-.04 9.499-.04 18.998-.09l3.56-.008 3.666-.016C60 123 60 123 61 124c.088 2.219.107 4.44.098 6.66l-.008 3.684-.028 4.719L61 154H31v31H0V93Z",
    fill: "#DCDCDC"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M525 124h30v30h31v31h31v31h30v30h-27l-1 2-1.723-3.332c-4.41-8.473-8.921-16.745-14.277-24.668l-2.082-3.102c-4.388-6.44-8.954-12.674-13.82-18.76C584 194.21 584 194.21 584 192h-2c-1.41-1.398-1.41-1.398-3.063-3.375l-1.914-2.238L575 184c-15.02-17.648-32.856-32.065-52-45l2-1v-14Z",
    fill: "#DCDBDA"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M646 393h1c.983 8.579 1.12 17.06 1.063 25.688L648 432h30v31l-30 1-1 29h-27v2h-2a687.46 687.46 0 0 1 4.383-10.738l1.347-3.233 1.395-3.341 1.418-3.4L630 466h2l-.203-2.305c.287-5.22 1.897-9.85 3.453-14.82 3.288-10.867 5.777-21.702 7.75-32.875l.648-3.52c1.147-6.47 1.862-12.93 2.352-19.48Z",
    fill: "#DDD"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M185 617h31v30h30v-28l2 1-1 58h-31v-30h-31v-31Z",
    fill: "#F6F6F6"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M339 62h31v30h31V62h31l-1 30c-20.246 1.78-40.303 2.223-60.625 2.25l-3.99.015c-3.788.012-7.575.009-11.362 0l-3.494.013-3.227-.02-2.821-.004C343 94 343 94 339 92V62Z",
    fill: "#DCDBDB"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M62 339h30c1.125 12.38 1.125 12.38 1.221 16.915l.07 3.081.06 3.2.07 3.375c.048 2.331.093 4.662.137 6.993.067 3.586.145 7.171.223 10.756.045 2.271.09 4.542.133 6.813l.072 3.26.052 2.986.051 2.639C94 401 94 401 93 402a148.134 148.134 0 0 0-.316 6.441l-.116 3.561-.13 4.56L92 431l-30 1v-31h30v-31H62v-31Z",
    fill: "#DCDADA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M339 679h31v30h31v31h-31l-1-31h-30v-30Z",
    fill: "#DCDCDB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124 617h30v30c9.828-.04 9.828-.04 19.656-.09l3.684-.008 3.793-.016C184 647 184 647 185 648c.088 2.219.107 4.44.098 6.66l-.008 3.684-.028 4.718L185 678h-31v-30h-30v-31Z",
    fill: "#F6F6F6"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M617 124h31v30h30v31l-14.938.063-4.718.027-3.684.008-3.793.016C648 185 648 185 647 184a152.47 152.47 0 0 1-.098-6.66l.008-3.684.028-4.719L647 154h-30v-30Z",
    fill: "#F6F6F7"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M524 31h31l1 30 30 1 .063 13.313.027 4.188.008 3.3.016 3.38C586 89 586 89 585 92h-30V62c-9.828.04-9.828.04-19.656.09l-3.684.008-3.793.016C525 62 525 62 524 61a152.47 152.47 0 0 1-.098-6.66l.008-3.684.028-4.718L524 31Z",
    fill: "#F6F6F6"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M586 555h30c1.396 2.791 1.218 5.202 1.316 8.32l.116 3.43.13 4.375L618 585l30 1-1 30h-30v-30h-31v-31Z",
    fill: "#DCDCDC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M709 31h31v31h-31v30h-30l-.063-14.438-.027-4.56-.008-3.56-.016-3.666C679 63 679 63 680 62c2.144-.159 4.293-.251 6.441-.316l3.561-.116 4.56-.13L709 61V31Z",
    fill: "#F6F6F6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m499 616 25 1 1 30 30 1v30h-31v-30l-31-1v-27l5-2 1-2Z",
    fill: "#F6F7F7"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m587 542 1 2-1 2a268.266 268.266 0 0 0-.316 8.945l-.063 2.682c-.066 2.833-.125 5.665-.183 8.498l-.131 5.754c-.108 4.707-.207 9.414-.307 14.121h-31v31c-7.116.03-7.116.03-14.375.063l-4.533.027-3.553.008-3.65.016C526 617 526 617 524 616a269.293 269.293 0 0 1-.313-6.688l-.175-3.761c.81-5.894 4.943-8.154 9.37-11.63a901.749 901.749 0 0 1 4.243-3.171c.715-.541 1.43-1.083 2.168-1.64l2.09-1.563 1.887-1.411C545 585 545 585 548 584v-2h2v-2c1.536-1.348 3.132-2.627 4.75-3.875 10.03-8.027 20.103-17.404 27.25-28.125h2l.938-2.438C586 543 586 543 587 542Z",
    fill: "#F5F5F5"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M164 555a85.437 85.437 0 0 1 5.25 5.563c.983 1.102 1.968 2.204 2.953 3.304l1.451 1.632c6.19 6.905 13.082 12.764 20.346 18.501l2.14 1.7c2.365 1.878 4.736 3.746 7.11 5.612l2.292 1.815c4.323 3.376 8.622 6.282 13.458 8.873l-2 2-1 12h-31v-30h-31v-30c7.193-2.398 7.193-2.398 10-1Z",
    fill: "#DBDCDB"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m524 600 2 1-1 1-1 14 31 1v30h29v1c-7.675.023-15.35.04-23.026.052-3.564.005-7.127.012-10.691.023-4.093.013-8.186.018-12.28.023l-3.894.015h-3.58l-3.169.007C525 648 525 648 524 647a152.47 152.47 0 0 1-.098-6.66l.005-2.014c.005-2.13.018-4.259.03-6.389A3970.039 3970.039 0 0 1 524 617l-2.08.033c-3.098.041-6.196.067-9.295.093l-3.273.05-3.125.02-2.889.032C501 617 501 617 499 615l1.541-.839c2.343-1.278 4.682-2.563 7.022-3.848l2.423-1.319c4.929-2.715 9.5-5.632 14.014-8.994Z",
    fill: "#DDD"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m527.867 92.886 3.793.016 3.684.008 4.719.027L555 93v30h-31l-.062-14.438-.028-4.56-.008-3.56-.016-3.666c.155-3.787.183-3.74 3.981-3.89Zm-17.539 30.016 2.422.01 2.5.025 2.547.014c2.068.012 4.135.03 6.203.049v15c-4.825-1.206-8.432-3.37-12.687-5.875l-2.377-1.355-2.26-1.325-2.065-1.202C503 127 503 127 502 124c2.852-.814 5.366-1.119 8.328-1.098Z",
    fill: "#F7F6F7"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M647 350h1v20h30v31h-30c-1.125-10.125-1.125-10.125-1.114-13.877v-2.546l.016-2.643.005-2.787c.005-2.903.018-5.806.03-8.71A7223.638 7223.638 0 0 1 647 350Z",
    fill: "#DCDADA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M399 646c1.776 7.294 2.254 14.137 2.125 21.625L401 678h-31v-30h-18v-1a33313.423 33313.423 0 0 1 21.734-.573c2.651-.07 5.302-.14 7.954-.208l2.46-.067c4.952-.127 9.898-.172 14.852-.152Z",
    fill: "#DCD9D9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M555 709h31v31h-31v-31Z",
    fill: "#DCDCDC"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M401 709h31v31h-31v-31Zm-247 0h31v31h-31v-31Zm555 0h31v31h-31v-31Zm-185 0h31v31h-31v-31Z",
    fill: "#F6F6F6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M185 709h31v31h-31v-31ZM0 709h31v31H0v-31Zm586-92h31v31h-31v-31Z",
    fill: "#DCDCDC"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M0 617h31v31H0v-31Zm586-31h31v31h-31v-31Z",
    fill: "#F6F6F6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M555 586h31v31h-31v-31Z",
    fill: "#DCDCDC"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M0 555h31v31H0v-31Z",
    fill: "#F6F6F6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M0 401h31v31H0v-31Z",
    fill: "#DCDCDC"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M0 370h31v31H0v-31Z",
    fill: "#F6F6F6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M0 339h31v31H0v-31Z",
    fill: "#DCDCDC"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M709 339h31v31h-31v-31ZM0 308h31v31H0v-31Z",
    fill: "#F6F6F6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M709 185h31v31h-31v-31Z",
    fill: "#DCDCDC"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M0 185h31v31H0v-31Zm709-31h31v31h-31v-31Zm-123 0h31v31h-31v-31Z",
    fill: "#F6F6F6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M0 154h31v31H0v-31Zm154-31h31v31h-31v-31ZM709 0h31v31h-31V0Z",
    fill: "#DCDCDC"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M617 0h31v31h-31V0Zm-62 0h31v31h-31V0Z",
    fill: "#F6F6F6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M401 0h31v31h-31V0Z",
    fill: "#DCDCDC"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M370 0h31v31h-31V0Z",
    fill: "#F6F6F6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M339 0h31v31h-31V0Z",
    fill: "#DCDCDC"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M185 0h31v31h-31V0Z",
    fill: "#F6F6F6"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M154 0h31v31h-31V0Z",
    fill: "#DCDCDC"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M123 0h31v31h-31V0ZM0 0h31v31H0V0Z",
    fill: "#F6F6F6"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "m712.867 554.886 3.793.016 3.684.008 4.719.027L740 555v31h-31l-.062-14.938-.028-4.718-.008-3.684-.016-3.793c.152-3.829.152-3.829 3.981-3.98ZM0 524l14.938-.063 4.718-.027 3.684-.008 3.793-.016C30 524 30 524 31 525c.088 2.219.107 4.44.098 6.66l-.008 3.684-.027 4.718L31 555H0v-31Z",
    fill: "#DCDCDC"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "m0 123 14.938-.063 4.718-.027 3.684-.008 3.793-.016C30 123 30 123 31 124c.088 2.219.107 4.44.098 6.66l-.008 3.684-.027 4.719L31 154H0v-31Z",
    fill: "#F6F6F6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M524 0h31v31l-14.938.063-4.718.027-3.684.008-3.793.016C525 31 525 31 524 30a152.47 152.47 0 0 1-.098-6.66l.008-3.684.028-4.718L524 0Z",
    fill: "#DCDCDC"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M463 709h30v31h-31l-.063-14.375-.027-4.533-.008-3.553-.016-3.65C462 711 462 711 463 709Z",
    fill: "#F6F6F8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M339 709h30c1.12 3.357 1.114 5.882 1.098 9.418l-.008 3.423-.027 4.346L370 740h-31v-31Z",
    fill: "#F6F6F6"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M619 709c2.89-.34 2.89-.34 6.54-.293l3.552.023 4.533.082L648 709v31h-31l-.125-13.813-.055-4.346-.015-3.423-.032-3.507C617 712 617 712 619 709Z",
    fill: "#DCDCDC"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "m194.164 677.867 3.649-.004 3.812.012 3.836-.012 3.64.004 3.355.004C215 678 215 678 216 679c.088 2.219.107 4.44.098 6.66l-.008 3.684-.028 4.718L216 709h-31v-30c3.278-1.093 5.714-1.13 9.164-1.133Z",
    fill: "#F6F6F7"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M710 617h30v31h-31l-.063-12.688-.027-3.975-.008-3.161-.016-3.222C709 622 709 622 710 617Z",
    fill: "#DCDCDC"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M342.09 646.867c9.332.026 18.597.569 27.91 1.133v30h-31l-.063-14.938-.027-4.718-.008-3.684-.016-3.793c.151-3.806.151-3.806 3.204-4Z",
    fill: "#F6F6F6"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M648 339h30v31h-30l-.563-13.813c-.06-1.434-.122-2.868-.185-4.346l-.13-3.423-.144-3.507C647 342 647 342 648 339Z",
    fill: "#F6F6F7"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M679 185h30v31h-30l-.563-14.375c-.06-1.496-.122-2.992-.185-4.533l-.13-3.553-.144-3.65C678 187 678 187 679 185Z",
    fill: "#F7F7F7"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M401 31h31v31l-31-1V31Z",
    fill: "#F6F6F6"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M432 709h31l-1 31h-30v-31Z",
    fill: "#DCDCDC"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "m617 678 31 1v30h-31v-31Z",
    fill: "#F6F6F6"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M555 617h31v31l-31-1v-30Z",
    fill: "#F6F6F7"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M586 709h30c1.448 2.896 1.005 5.312.879 8.54l-.13 3.552-.187 4.533L616 740h-30v-31Z",
    fill: "#F6F6F6"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "m524 678 31 1v30h-31v-31Z",
    fill: "#DBDCDC"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M401 678v31h-31v-30l14.938-.5 4.718-.158 3.684-.123 3.793-.127C400 678 400 678 401 678Z",
    fill: "#F6F6F5"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M154 617h31v31l-31-1v-30Z",
    fill: "#DBDCDC"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M617 154h30l1 31h-31v-31Z",
    fill: "#DBDCDB"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M93 31h30v31H92l1-31Zm61 0h31v31l-31-1V31Z",
    fill: "#F6F6F6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M648 709h30v31h-30v-31Z",
    fill: "#F7F7F7"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M247 709h30v31h-30v-31Z",
    fill: "#DCDADB"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M31 709h30v31H31v-31Z",
    fill: "#F7F7F7"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M555 679h31v30h-31v-30Z",
    fill: "#F6F7F7"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M401 679h31v30h-31v-30Z",
    fill: "#DCDCDC"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M0 679h31v30H0v-30Z",
    fill: "#F6F6F6"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M709 648h31v30h-31v-30Z",
    fill: "#F7F7F7"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M586 648h31v30h-31v-30Z",
    fill: "#F6F7F7"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M185 648h31v30h-31v-30Z",
    fill: "#DBDBDC"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M0 648h31v30H0v-30Z",
    fill: "#DCDCDC"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M679 617h30v31h-30v-31Zm30-31h31v30h-31v-30Z",
    fill: "#F6F6F6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M0 586h31v30H0v-30Zm31-31h30v31H31v-31Z",
    fill: "#DCDCDC"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M648 555h30v31h-30v-31Z",
    fill: "#DBDBDB"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M62 555h30v31H62v-31Z",
    fill: "#F6F6F6"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M710 524h30v31h-30v-31Z",
    fill: "#F7F7F7"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M679 524h30v31h-30v-31Z",
    fill: "#DCDCDC"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M93 524h30v31H93v-31Z",
    fill: "#F7F7F7"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M709 463h31v30h-31v-30Z",
    fill: "#F6F6F6"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M0 463h31v30H0v-30Z",
    fill: "#DCDCDC"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M0 432h31v30H0v-30Z",
    fill: "#F6F6F6"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M710 401h30v31h-30v-31Z",
    fill: "#F7F7F7"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M710 370h30v31h-30v-31Z",
    fill: "#DBDBDB"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M62 370h30v31H62v-31Z",
    fill: "#F6F7F7"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M679 339h30v31h-30v-31ZM0 278h31v30H0v-30Z",
    fill: "#DCDCDC"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M0 247h31v30H0v-30Z",
    fill: "#F6F6F6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M0 216h31v30H0v-30Zm648-31h30v31h-30v-31Z",
    fill: "#DCDCDC"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M617 185h30v31h-30v-31Z",
    fill: "#F6F7F7"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M62 185h30v31H62v-31Z",
    fill: "#F6F6F6"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M31 185h30v31H31v-31Z",
    fill: "#DCDCDC"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M31 154h30v31H31v-31Z",
    fill: "#F7F7F7"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M93 154h30v31H93v-31Z",
    fill: "#F6F6F6"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M555 93h31v30h-31V93Z",
    fill: "#DCDCDC"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M709 62h31v30h-31V62Z",
    fill: "#DBDBDB"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M524 62h31v30h-31V62Z",
    fill: "#DBDCDC"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M370 62h31v30h-31V62Z",
    fill: "#F6F7F7"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M185 62h31v30h-31V62Z",
    fill: "#F7F7F7"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M0 62h31v30H0V62Z",
    fill: "#F6F6F6"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M185 31h31v30h-31V31Zm308 0h31v30h-31V31Z",
    fill: "#DBDBDB"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M309 31h30v31h-30V31Z",
    fill: "#DCDCDC"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M679 0h30v31h-30V0Z",
    fill: "#F7F7F7"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M648 0h30v31h-30V0ZM463 0h30v31h-30V0Z",
    fill: "#DCDCDC"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M432 0h30v31h-30V0ZM309 0h30v31h-30V0Z",
    fill: "#F7F7F7"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M247 0h30v31h-30V0Z",
    fill: "#F6F6F6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M93 0h30v31H93V0Z",
    fill: "#DCDCDC"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M62 0h30v31H62V0Z",
    fill: "#F7F7F7"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0h30v31H31V0Z",
    fill: "#DCDCDC"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "m281.776 708.886 3.665.016 3.561.008 4.56.027L308 709v31h-30l-.063-14.938-.027-4.718-.008-3.684-.016-3.793c.152-3.828.152-3.828 3.89-3.98Z",
    fill: "#F7F6F7"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "m712.867 493.886 3.793.016 3.684.008 4.719.027L740 494v30h-31l-.062-14.438-.028-4.56-.008-3.56-.016-3.666c.155-3.787.183-3.74 3.981-3.89Z",
    fill: "#DCDCDC"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M679 370h30v31l-14.438.063-4.56.027-3.56.008-3.666.016C680 401 680 401 679 400a152.47 152.47 0 0 1-.098-6.66l.008-3.684.028-4.719L679 370Z",
    fill: "#F6F6F6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M31 370h30l.063 14.938.027 4.718.008 3.684.016 3.793C61 400 61 400 60 401a142.61 142.61 0 0 1-6.441.098l-3.561-.008-4.56-.027L31 401v-31Z",
    fill: "#DBDBDB"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "m712.867 277.886 3.793.016 3.684.008 4.719.027L740 278v30h-31l-.062-14.438-.028-4.56-.008-3.56-.016-3.666c.155-3.787.183-3.74 3.981-3.89Z",
    fill: "#F7F7F7"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "m558.867 123.886 3.793.016 3.684.008 4.719.027L586 124v30h-31l-.062-14.438-.028-4.56-.008-3.56-.016-3.666c.155-3.787.183-3.74 3.981-3.89Z",
    fill: "#F6F6F7"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "m188.867 92.886 3.793.016 3.684.008 4.719.027L216 93v30h-31l-.062-14.438-.028-4.56-.008-3.56-.016-3.666c.155-3.787.183-3.74 3.981-3.89Z",
    fill: "#DBDBDB"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "m157.867 61.886 3.793.016 3.684.008 4.719.027L185 62v30h-31l-.062-14.438-.028-4.56-.008-3.56-.016-3.666c.155-3.787.183-3.74 3.981-3.89ZM370 31h31l.063 14.438.027 4.56.008 3.56.016 3.666C401 60 401 60 400 61c-2.219.088-4.44.107-6.66.098l-3.684-.008-4.719-.028L370 61V31ZM278 0h30l.063 14.938.027 4.718.008 3.684.016 3.793C308 30 308 30 307 31a142.61 142.61 0 0 1-6.441.098l-3.561-.008-4.56-.027L278 31V0ZM70.32 708.902l3.43.008 4.375.028L92 709v31H62v-30c2.818-1.41 5.173-1.112 8.32-1.098Zm617 0 3.43.008 4.375.028L709 709v31h-30v-30c2.818-1.41 5.173-1.112 8.32-1.098Z",
    fill: "#DCDCDC"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M93 216h30l.063 14.375.027 4.533.008 3.553.016 3.65C123 245 123 245 122 247H93v-31Z",
    fill: "#F6F6F6"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "m101.32 184.902 3.43.008 4.375.028L123 185v31H93v-30c2.818-1.41 5.173-1.112 8.32-1.098Z",
    fill: "#DBDBDB"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M679 31h30v30c-2.818 1.41-5.173 1.112-8.32 1.098l-3.43-.008-4.375-.028L679 62V31Zm-124 0h31l.063 13.875.027 4.375.008 3.43.016 3.523C586 59 586 59 585 61h-30V31ZM133.2 708.902l3.299.008 4.189.028L154 709v31h-30v-30c3.297-1.1 5.73-1.114 9.2-1.098Z",
    fill: "#DCDCDC"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "m162.285 678.867 3.795-.004 3.982.012 3.995-.012 3.79.004 3.5.004C184 679 184 679 185 680c.088 2.146.107 4.294.098 6.441l-.008 3.561-.028 4.56L185 709h-31v-29c2.806-1.403 5.15-1.13 8.285-1.133Z",
    fill: "#DBDCDC"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "m626.418 493.902 3.423.008 4.346.027L648 494v30h-31v-29c3.357-1.12 5.882-1.114 9.418-1.098Z",
    fill: "#F6F7F6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M120 491a66.377 66.377 0 0 1 5.688 8.625l1.324 2.352C128 504 128 504 128 506h-2v-2h-2l-1 20H93v-30l27-1v-2Z",
    fill: "#DCDBDA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M710 309h30v30h-31l-.063-13.313-.027-4.188-.008-3.3-.016-3.38C709 312 709 312 710 309Z",
    fill: "#DCDCDC"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "m103.078 708.902 3.17.008 4.002.028L123 709v31H93v-30c3.648-.912 6.357-1.116 10.078-1.098Z",
    fill: "#F6F6F6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "m103.078 554.902 3.17.008 4.002.028L123 555v31H93v-30c3.648-.912 6.357-1.116 10.078-1.098Z",
    fill: "#DCDCDC"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M710 124h30v30h-31l-.063-12.75-.027-4.003-.008-3.169-.016-3.237C709 128 709 128 710 124Z",
    fill: "#DBDBDC"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M710 93h30v30h-31l-.063-12.188-.027-3.817-.008-3.038-.016-3.094C709 98 709 98 710 93Z",
    fill: "#F7F6F6"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M124 124h30v30l-14.938.063-4.718.027-3.684.008-3.793.016C124 154 124 154 123 153a91.96 91.96 0 0 1-.133-5.172l-.004-3.203.012-3.375-.012-3.328.004-3.219.004-2.948C123 129 123 129 124 124Z",
    fill: "#F6F6F6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M647 392h1v9h30v30l-30 1-1-40Z",
    fill: "#F6F7F7"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M216 93h31v28l-3-1v2c-2.714 1.357-4.848 1.112-7.883 1.098l-3.184-.008-4.058-.028L216 123V93Z",
    fill: "#F6F6F7"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M648 309h30v30h-30l-1 6h-1l.184-2.543c.776-11.146 1.305-22.296 1.816-33.457Z",
    fill: "#DCDBDC"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M710 247h30v30h-31l-.063-8.25-.027-2.517c-.023-6.522.542-12.652 1.09-19.233Z",
    fill: "#DCDBDB"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M700.75 153.938 709 154v31l-14.438.063-4.56.027-3.56.008-3.666.016C680 185 680 185 679 184a142.535 142.535 0 0 1-.098-6.441l.01-3.955.025-4.167c.006-1.392.01-2.785.014-4.177.012-3.42.028-6.84.049-10.26 7.27-.69 14.448-1.143 21.75-1.063Z",
    fill: "#DCDCDC"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "m589.776 92.886 3.665.016 3.955.01 4.166.025c1.393.006 2.786.01 4.178.014 3.42.012 6.84.028 10.26.049 1.64 3.281 1.142 6.898 1.125 10.5l.012 2.32c-.01 5.843-.55 11.305-1.137 17.18h-30l-.063-14.438-.027-4.56-.008-3.56-.016-3.666c.153-3.733.157-3.737 3.89-3.89Z",
    fill: "#F7F6F6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M679 401h30v30l-30 1c-1.664-26.007-1.664-26.007 0-31Z",
    fill: "#DCDCDC"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M345 646v1l-5 1-1 30h-30v-30c13.375-.438 13.375-.438 17.591-.568l3.307-.116 3.396-.11c4.074-.31 7.414-1.285 11.706-1.206Z",
    fill: "#DBDBDC"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M494 93h30v30c-8.688.375-8.688.375-11.397.478-4.78.216-4.78.216-9.248 1.811L501 126l-7-4V93Z",
    fill: "#DCDBDB"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M401 648h31l-1 30h-30v-30Z",
    fill: "#F6F7F6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M154 586h31v30h-30l-1-30Z",
    fill: "#F6F7F7"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M524 709v31h-30v-30l13.313-.5 4.188-.158a3522625531.997 3522625531.997 0 0 0 6.68-.25A178.81 178.81 0 0 1 524 709Z",
    fill: "#DBDBDC"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M93 617h30v30l-30 1v-31Z",
    fill: "#DBDBDB"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "m617 555 30 1 1 30-14.938.063-4.718.027-3.684.008-3.793.016C618 586 618 586 617 585a152.47 152.47 0 0 1-.098-6.66l.008-3.684.028-4.718L617 555Z",
    fill: "#F6F6F6"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M617 93h31l-1 30h-30V93Z",
    fill: "#DCDBDB"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "m62 524 30 1v30H62v-31Zm555-308h30v30h-27l-1 2c-2.838-3.987-3.327-6.54-3.074-11.395l.146-3.284.24-4.133L617 216Z",
    fill: "#DBDBDB"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M617 62h31l-1 30h-30V62Z",
    fill: "#F6F7F7"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M617 617h30v30l-30 1v-31Z",
    fill: "#F7F7F7"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "m247 618-1 29h-30v-30l12.125-.625 3.79-.213 3.03-.139 3.079-.158C241 616 241 616 247 618Zm-216-1h30v30l-30 1v-31Z",
    fill: "#DBDBDB"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "m126.867 585.886 3.793.016 3.684.008 4.719.027L154 586v30h-30l-.562-14.438-.186-4.56-.13-3.56-.144-3.666c.03-3.796.092-3.74 3.89-3.89Z",
    fill: "#DBDCDB"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M62 432h30v30l-30 1v-31Z",
    fill: "#F7F7F7"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "m31 308 30 1v30H31v-31Z",
    fill: "#DBDBDB"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M432 62h31l-1 30h-30V62Z",
    fill: "#F7F7F7"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M617 31h31l-1 30h-30V31Z",
    fill: "#DBDBDB"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M586 0h30v30l-30 1V0Z",
    fill: "#DCDCDC"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M216 710h30v30h-30v-30Z",
    fill: "#F7F6F7"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M463 679h30v30h-30v-30Z",
    fill: "#DBDBDD"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M679 679h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M648 679h30v30h-30v-30Z",
    fill: "#DCDCDC"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M494 679h30v30h-30v-30Zm-62 0h30v30h-30v-30Z",
    fill: "#F6F7F7"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M309 679h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M278 679h30v30h-30v-30Z",
    fill: "#DCDBDB"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M247 679h30v30h-30v-30Z",
    fill: "#F8F6F7"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M216 679h30v30h-30v-30Z",
    fill: "#DCDBDB"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M62 679h30v30H62v-30Z",
    fill: "#F7F7F7"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M31 679h30v30H31v-30Z",
    fill: "#DBDBDB"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M679 648h30v30h-30v-30Z",
    fill: "#DCDCDC"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M648 648h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M617 648h30v30h-30v-30Z",
    fill: "#DCDCDC"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M494 648h30v30h-30v-30Z",
    fill: "#DBDBDB"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M463 648h30v30h-30v-30Z",
    fill: "#F7F7F9"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M432 648h30v30h-30v-30Z",
    fill: "#DBDCDC"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M278 648h30v30h-30v-30Z",
    fill: "#F7F6F7"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M247 648h30v30h-30v-30Z",
    fill: "#DDDBDC"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M124 648h30v30h-30v-30Z",
    fill: "#DBDCDB"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M93 648h30v30H93v-30Z",
    fill: "#F7F7F7"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M62 648h30v30H62v-30Z",
    fill: "#DBDBDB"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M31 648h30v30H31v-30Z",
    fill: "#F7F7F7"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M648 617h30v30h-30v-30Z",
    fill: "#DBDBDB"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "m70.32 616.902 3.43.008 4.375.028L92 617v30l-30 1v-30c2.818-1.41 5.173-1.112 8.32-1.098Z",
    fill: "#F7F7F7"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M679 586h30v30h-30v-30Z",
    fill: "#DBDBDB"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M648 586h30v30h-30v-30Zm-555 0h30v30H93v-30Z",
    fill: "#F7F7F7"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M62 586h30v30H62v-30Z",
    fill: "#DBDBDB"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M31 586h30v30H31v-30Zm617-61h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M617 525h30v30h-30v-30Z",
    fill: "#DCDCDC"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M679 494h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M648 494h30v30h-30v-30Z",
    fill: "#DBDBDB"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M62 494h30v30H62v-30Z",
    fill: "#F7F7F7"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M31 494h30v30H31v-30Zm648-31h30v30h-30v-30Z",
    fill: "#DBDBDB"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M648 463h30v30h-30v-30Z",
    fill: "#F7F7F6"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M62 463h30v30H62v-30Z",
    fill: "#DBDBDB"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M31 463h30v30H31v-30Z",
    fill: "#F7F7F7"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M710 432h30v30h-30v-30Z",
    fill: "#DBDBDB"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M679 432h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M31 432h30v30H31v-30Z",
    fill: "#DBDBDB"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M679 309h30v30h-30v-30Zm-617 0h30v30H62v-30Z",
    fill: "#F7F7F7"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M679 278h30v30h-30v-30Z",
    fill: "#DBDBDB"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M648 278h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M62 278h30v30H62v-30Z",
    fill: "#DBDBDB"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M31 278h30v30H31v-30Zm648-31h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M648 247h30v30h-30v-30Z",
    fill: "#DCDBDB"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M62 247h30v30H62v-30Z",
    fill: "#F7F7F7"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M31 247h30v30H31v-30Z",
    fill: "#DBDBDB"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M710 216h30v30h-30v-30Z",
    fill: "#F7F6F7"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M679 216h30v30h-30v-30Z",
    fill: "#DBDBDB"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M648 216h30v30h-30v-30Z",
    fill: "#F7F7F7"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M62 216h30v30H62v-30Z",
    fill: "#DBDBDB"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M31 216h30v30H31v-30Z",
    fill: "#F7F7F7"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M62 155h30v30H62v-30Z",
    fill: "#DCDCDC"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M648 124h30v30h-30v-30Zm-62 0h30v30h-30v-30Z",
    fill: "#DCDBDC"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M93 124h30v30H93v-30Z",
    fill: "#DBDBDB"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M62 124h30v30H62v-30Z",
    fill: "#F6F6F6"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M679 93h30v30h-30V93Z",
    fill: "#DCDBDB"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M648 93h30v30h-30V93Zm-493 0h30v30h-30V93Z",
    fill: "#F7F7F7"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M124 93h30v30h-30V93Z",
    fill: "#DBDBDB"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M93 93h30v30H93V93Z",
    fill: "#F7F7F7"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M62 93h30v30H62V93Zm586-31h30v30h-30V62Z",
    fill: "#DBDBDB"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M586 62h30v30h-30V62Z",
    fill: "#DBDCDB"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M494 62h30v30h-30V62Z",
    fill: "#F7F7F7"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M463 62h30v30h-30V62Z",
    fill: "#DBDBDB"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M309 62h30v30h-30V62Z",
    fill: "#F7F7F7"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M278 62h30v30h-30V62Z",
    fill: "#DBDBDB"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M247 62h30v30h-30V62Z",
    fill: "#F7F7F7"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M216 62h30v30h-30V62Z",
    fill: "#DBDBDB"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M124 62h30v30h-30V62Z",
    fill: "#F7F7F7"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M93 62h30v30H93V62Z",
    fill: "#DBDBDB"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M62 62h30v30H62V62Z",
    fill: "#F6F6F6"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M31 62h30v30H31V62Z",
    fill: "#DBDBDB"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M648 31h30v30h-30V31Zm-62 0h30v30h-30V31Zm-123 0h30v30h-30V31Z",
    fill: "#F7F7F7"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M432 31h30v30h-30V31Z",
    fill: "#DBDBDB"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M278 31h30v30h-30V31Z",
    fill: "#F7F7F7"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M247 31h30v30h-30V31Z",
    fill: "#DBDBDB"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M216 31h30v30h-30V31Z",
    fill: "#F7F7F7"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M124 31h30v30h-30V31Zm-62 0h30v30H62V31Z",
    fill: "#DBDBDB"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M31 31h30v30H31V31Z",
    fill: "#F7F7F7"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M0 31h30v30H0V31Z",
    fill: "#DBDBDB"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M216 0h30v30h-30V0Z",
    fill: "#DCDCDC"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M710 679h30v30l-14.438.063-4.56.027-3.56.008-3.666.016C711 709 711 709 710 708a142.535 142.535 0 0 1-.098-6.441l.008-3.561.028-4.56L710 679Z",
    fill: "#DBDBDB"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "m127.776 678.886 3.665.016 3.561.008 4.56.027L154 679v30h-30l-.063-14.438-.027-4.56-.008-3.56-.016-3.666c.153-3.733.157-3.737 3.89-3.89Z",
    fill: "#F6F7F7"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m96.776 678.886 3.665.016 3.561.008 4.56.027L123 679v30H93l-.063-14.438-.027-4.56-.008-3.56-.016-3.666c.153-3.733.157-3.737 3.89-3.89Z",
    fill: "#DBDBDB"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m34.776 92.886 3.665.016 3.561.008 4.56.027L61 93v30H31l-.063-14.438-.027-4.56-.008-3.56-.016-3.666c.153-3.733.157-3.737 3.89-3.89ZM679 124h29c1.41 2.818 1.112 5.173 1.098 8.32l-.008 3.43-.028 4.375L709 154h-30v-30Z",
    fill: "#F7F7F7"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M138 523c3.15 3.15 5.653 6.056 8.25 9.625l2.14 2.914C150 538 150 538 150 540h2c3.754 5.856 2.875 7.124 2 15h-30v-31l14-1Z",
    fill: "#DBDBDC"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m133.2 184.902 3.661.01 3.827.025 3.86.014c3.151.012 6.302.028 9.452.049.646 10.801.646 10.801-1.758 15.262l-2.367 2.425C145.688 207.24 142.33 211.792 139 217l-15-1v-30c3.297-1.1 5.73-1.114 9.2-1.098Z",
    fill: "#F6F5F5"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m497 616 2 1v2l-6 1v27l-30 1-1-14-2-2 3.078-1.137c16.566-5.987 16.566-5.987 32.18-14.043L497 616Z",
    fill: "#DBDADA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M93 247h28c-4.75 11.75-4.75 11.75-6.222 15.374A315.105 315.105 0 0 0 107 284c-1.125-3.75-1.125-3.75 0-6l-14-1v-30Z",
    fill: "#DCDADB"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m632 460 2 2 14 1-1 30h-27v2h-2a687.46 687.46 0 0 1 4.383-10.738l1.347-3.233 1.395-3.341 1.418-3.4L630 466h2v-6Z",
    fill: "#DBDAD7"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M155 155h30c0 9 0 9-1.906 11.566-.856.66-1.712 1.318-2.594 1.996l-2.75 2.231L175 173a193.869 193.869 0 0 0-4.5 4.375l-1.906 1.898c-1.784 1.843-1.784 1.843-3.594 4.727-2.129.547-2.129.547-4.563.75l-2.44.234L156 185c-1-1-1-1-1.114-3.776l.016-3.665.008-3.561.028-4.56L155 155Z",
    fill: "#F6F6F7"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M247 93h30l1 13 2 2-2.902 1.066c-10.135 3.75-20.123 7.778-30.098 11.934V93Z",
    fill: "#DBDBDC"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M463 93h30v27c-6.741-1.124-6.741-1.124-10.188-2.75l-2.304-1.07L478 115a4024.71 4024.71 0 0 0-5.813-2.625A265.442 265.442 0 0 1 463 108V93Z",
    fill: "#F5F6F5"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M620 247h28l-1 30h-15c-3.37-5.615-3.37-5.615-4.5-8.813l-.75-2.07-1.5-4.234c-1.124-3.103-2.203-5.806-3.938-8.633C620 251 620 251 620 247Z",
    fill: "#F7F6F4"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "m97.16 462.902 3.903.036 3.91.027L108 463c5.03 9.595 9.864 19.32 12 30H93c-.023-4.112-.043-8.223-.055-12.335-.005-1.4-.012-2.8-.02-4.2a1697.68 1697.68 0 0 1-.023-6.024l-.016-3.665c.162-3.95.265-3.75 4.274-3.874Z",
    fill: "#F6F6F6"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M678 556h1v60h61v1h-30v5h-1v-5h-30v61h61v1h-30l1 30h-2v-30h-30v30l2 1h-2v30h-1v-61h-59v-1h28v-30h-29v-1h29v-30h-30v-1h30v-28h1v28h30v-60Zm-30 61v30h30v-30h-30Zm0 31v30h30v-30h-30Z",
    fill: "#E9E9E9"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M432 93h31v15l4 1c-2 1-2 1-3.933.519-.78-.28-1.56-.56-2.364-.847l-2.638-.922-2.815-1c-8.357-2.89-16.528-5.21-25.25-6.75l2-1v-6Z",
    fill: "#DAD6D5"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M278 632c7.715 1.367 7.715 1.367 10 2l1 2c2.044.622 2.044.622 4.5 1 4.866.883 9.676 1.91 14.5 3v8h-30v-16Z",
    fill: "#DCDCDC"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M632 278h16v30h-8l-.734-3.078c-1.862-7.685-3.888-15.2-6.532-22.664C632 280 632 280 632 278Z",
    fill: "#D9DCDA"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M98 426c1.58 2.892 2.454 5.523 3.113 8.746l.588 2.77.612 2.921c1.682 7.794 3.667 14.98 6.867 22.297L110 465l-1 2-1-4-15-1v-30h5v-6Z",
    fill: "#DBD7D6"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M462 633v14h-30v-6c5.685-2.213 11.371-4.066 17.25-5.688l2.39-.681 2.313-.643 2.068-.577C458 633 458 633 462 633Z",
    fill: "#F6F4F4"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M641 432h6v30h-14c.606-5.962 1.792-11.493 3.438-17.25l.658-2.39c1.032-3.67 2.12-6.977 3.904-10.36Z",
    fill: "#F7F5F6"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M93 278h14c-2.098 10.07-4.45 20.036-7 30h-7v-30Z",
    fill: "#F5F4F4"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M278 93h30v7l-2.133.516c-7.006 1.72-13.926 3.637-20.836 5.714C282 107 282 107 278 107V93Z",
    fill: "#F6F6F7"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "m123 502 1 2h2v2h3l1.207 2.266 1.606 2.984 1.582 2.953c1.503 2.772 1.503 2.772 3.304 4.969C138 521 138 521 138 524h-14v63h-1v-85Z",
    fill: "#F1F0F0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M524 94h1v29h-1V94Zm-13.672 28.902 2.422.01 2.5.025 2.547.014c2.068.012 4.135.03 6.203.049v15c-4.825-1.206-8.432-3.37-12.688-5.875l-2.376-1.355-2.26-1.325-2.065-1.202C503 127 503 127 502 124c2.852-.814 5.366-1.119 8.328-1.098Z",
    fill: "#F3F1F1"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M616 497h1c.029 4.312.047 8.625.063 12.938l.025 3.732.01 3.545.016 3.285C617 523 617 523 616 524c-2.353.073-4.708.084-7.063.063l-3.91-.028L602 524v2h-2c1.566-4.308 3.683-8.062 6-12h2l.625-2.313c1.934-5.186 4.654-9.877 7.375-14.687Z",
    fill: "#DAD7D7"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "m244 120 3 1c-2.868 2.257-5.777 4.043-9 5.75-5.198 2.791-10.292 5.732-15.371 8.734-2.167 1.25-4.392 2.397-6.629 3.516v-15l28-2v-2Z",
    fill: "#DBD9D9"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M464 647h57v1h-27v30h30v1h-30v30h27v1h-27v30h-1c-.157-7.566-.305-15.131-.443-22.697-.064-3.517-.131-7.034-.205-10.55-.41-19.642-.152-39.113.648-58.753h-29v-1Z",
    fill: "#E8E9EA"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M217 603c4.748.367 8.161 2.783 12 5.375 1.208.8 2.416 1.6 3.625 2.398l1.73 1.156c1.5.977 3.04 1.89 4.583 2.798L241 616v1h-25c-.098-10.059-.098-10.059 0-13l1-1Z",
    fill: "#F4F4F1"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M617 216v25c-3.325-2.217-4.076-3.634-5.875-7.125-2.221-4.23-4.573-8.257-7.242-12.219C603 220 603 220 603 217c4.185-2.092 9.321-1 14-1Z",
    fill: "#F5F3F1"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "m524 600 2 1-1 1a193.96 193.96 0 0 0-.563 7.063l-.253 3.91L524 616c-3.79.225-7.583.427-11.375.625l-3.273.195-3.125.157-2.889.158C501 617 501 617 499 615l1.541-.839c2.343-1.278 4.682-2.563 7.022-3.848l2.423-1.319c4.929-2.715 9.5-5.632 14.014-8.994Z",
    fill: "#DCD6D7"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M94 336h1c1.242 5.75 1.11 11.393 1.063 17.242l-.012 3.28c-.016 4.614-.044 9.228-.072 13.842-.018 3.376-.03 6.752-.041 10.128l-.026 3.132c-.018 5.57.308 10.863 1.088 16.376.068 1.426.11 2.854.098 4.281l-.01 2.11-.025 2.109-.014 2.203c-.012 1.766-.03 3.531-.049 5.297h-1c-2.848-15.095-3.164-29.998-3.13-45.306.005-2.953 0-5.905-.007-8.858 0-1.909.002-3.818.004-5.727l-.006-2.627c.022-5.879.457-11.643 1.139-17.482Z",
    fill: "#DB2834"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M309 642c6.112-.155 11.845.401 17.875 1.375l2.586.383 2.469.39 2.226.35C336 645 336 645 338 647c-2.518 1.259-4.27 1.13-7.086 1.133l-3.07.004-3.219-.012-3.195.012-3.078-.004-2.818-.004c-2.327-.118-4.307-.472-6.534-1.129v-5Z",
    fill: "#F7F1F5"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M435 641h-3v6h-30c2.497-2.497 3.883-2.501 7.34-3.035l3.22-.514 3.377-.514c2.197-.342 4.394-.687 6.59-1.035l2.961-.453c6.954-1.243 6.954-1.243 9.512-.449Z",
    fill: "#D7D8D4"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M93 401c2.472 3.709 2.94 7.251 3.625 11.563l.4 2.442c.89 5.729 1.256 11.192.975 16.995h-5v-31Z",
    fill: "#F1EEEE"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M249 334h1c.028 1.5.047 3 .063 4.5l.035 2.531C250 344 250 344 249.5 347.671c-.538 4.202-.629 8.317-.598 12.548l.005 2.252c.005 2.343.018 4.686.03 7.029A4692.606 4692.606 0 0 0 249 386h-1c-1.639-8.346-2.353-16.375-2.313-24.875l.004-3.427c.095-8.238.891-15.783 3.309-23.698Z",
    fill: "#EF1622"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M645 338h1c1.073 6.086 1.13 12.013 1.098 18.184l-.005 3.198c-.005 3.352-.018 6.704-.03 10.055-.006 2.281-.01 4.562-.014 6.842A9319.85 9319.85 0 0 1 647 393h-1c-.807-6.494-1.209-12.893-1.352-19.434l-.07-2.906c-.047-2.01-.092-4.019-.136-6.028a2703 2703 0 0 0-.223-9.255c-.045-1.958-.09-3.915-.133-5.873l-.072-2.8-.052-2.58-.051-2.274C644 340 644 340 645 338Z",
    fill: "#D72A3B"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "m93 309 5 1c.17 5.722-.468 11.105-1.375 16.75l-.383 2.574-.39 2.473-.35 2.23C95 336 95 336 93 339v-30Z",
    fill: "#D9D6D4"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M645 404c2.202 3.303 2.24 4.275 2.195 8.105l-.02 2.979-.05 3.103-.027 3.14c-.024 2.557-.057 5.115-.098 7.673l-2 1v-4l-1 6h-3l-1 3c.886-6.502 1.976-12.967 3.063-19.438l.564-3.373L645 404Z",
    fill: "#D9CACC"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "m364 303 1 3-1.773-.656c-6.197-2.01-11.95-2.646-18.414-2.656l-2.266-.016c-5.132.063-9.61.925-14.547 2.328v-2h4v-2c10.554-3.311 22.14-3.626 32 2Z",
    fill: "#EB2138"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M309 93c3.75-.058 7.5-.094 11.25-.125l3.223-.05 3.105-.02 2.857-.032c2.665.236 4.284.87 6.565 2.227-2.895.505-5.79 1.004-8.688 1.5l-2.474.434c-3.988.678-7.775 1.265-11.838 1.066v-2h-4v-3Z",
    fill: "#D8D5D4"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M642 309h5v18l-3 1c-1.173-6.378-2.295-12.503-2-19Z",
    fill: "#F4F4F3"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M415 198c9.693-.77 17.893 2.042 27 5v3c-9.03-2.232-18.042-4.495-27-7v-1Z",
    fill: "#E42940"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M281 496h2c-.504 7.102-1.744 13.748-3.563 20.625l-.708 2.754c-.57 2.209-1.146 4.416-1.729 6.621l-1-4h-2v-2l2-1c.407-2.322.744-4.657 1-7h2l-.125-3.5c-.016-4.445.907-8.237 2.125-12.5Z",
    fill: "#D72B3F"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M646 393h1c.983 8.58 1.12 17.059 1.063 25.688l-.014 3.896c-.012 3.139-.028 6.277-.049 9.416h-4l1-10h1v-29Z",
    fill: "#DDE2DF"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M213 280h2a41.727 41.727 0 0 1-2.629 7.89l-.947 2.15-.987 2.21-.998 2.258A2236.77 2236.77 0 0 1 207 300c-2-3-2-3-1.625-5.438L206 292v-4h2v-2h3l2-6Z",
    fill: "#EB0524"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "m356 194 1 2c-3.374.507-6.75 1.004-10.125 1.5l-2.883.434c-4.704.686-9.222 1.259-13.992 1.066v-2h10v-2c5.361-1.129 10.553-1.097 16-1Z",
    fill: "#E31F34"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "m587 542 1 2-1 2c-.225 1.537-.408 3.08-.563 4.625L586 555l-10 1c4.492-6.25 4.492-6.25 6-8h2l.938-2.438C586 543 586 543 587 542Z",
    fill: "#DBCDD1"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M164 185a105.022 105.022 0 0 1-4 5h-2l-.875 1.938C156 194 156 194 154 195v-10c3.663-.75 6.424-1.238 10 0Z",
    fill: "#E0DCD9"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M395 526h21v3h-16v-2h-5v-1Z",
    fill: "#E94359"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M194 350h1l.076 1.83c.657 16.104.657 16.104 1.924 32.17-5.776-11.14-4.001-21.756-3-34Z",
    fill: "#CF323F"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M381 332h2v23l-3-1 1-22Z",
    fill: "#DA2432"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M154 546c4.008 2.004 5.414 3.49 8 7l-1 2c-2.066.414-2.066.414-4.563.625l-2.503.227L152 556l2-1v-9Z",
    fill: "#E8EFED"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M185 154h10l-1 2h-2v2c-2.208 1.859-4.608 3.377-7 5v-9Z",
    fill: "#D8DAD8"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "m226 132 2 1c-5.371 5.67-5.371 5.67-9 7h-3l-.563 1.875c-2.151 3.181-4.812 3.32-8.437 4.125 3.468-3.825 7.456-6.458 11.75-9.25l2.113-1.39c1.71-1.125 3.423-2.243 5.137-3.36Z",
    fill: "#E61E37"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M324 644c1.959.114 3.917.241 5.875.375 1.09.07 2.181.14 3.305.21C336 645 336 645 338 647c-2.4 1.2-3.894 1.115-6.57 1.098l-2.715-.01-2.84-.025-2.863-.014c-2.338-.012-4.675-.028-7.012-.049v-1l8-1v-2Z",
    fill: "#ECF2EF"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M327 641c10.175 2.175 10.175 2.175 13 5-2.896-.31-5.792-.623-8.688-.938l-2.474-.263c-3.993-.437-7.915-.912-11.838-1.799 3.568-2.379 5.888-2.495 10-2Z",
    fill: "#E12F41"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M303 609c1.047 3.726 1.074 7.13 1 11h-5l-.813 2.375C297 625 297 625 294 627c1.544-4.14 3.51-7.936 5.625-11.813l.984-1.81c.795-1.46 1.593-2.919 2.391-4.377Z",
    fill: "#E8183A"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "m553 578 2 1v7h-10l1-2h2v-2h2v-2l3-2Z",
    fill: "#DDD9DC"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M638 440c2 2 2 2 2.195 3.945L640 450h-2v4h-2v4h-2c.584-6.304 2.04-11.987 4-18Z",
    fill: "#EDE8E2"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M102 296c2 2 2 2 2.313 4.5-.423 4.73-1.821 9.007-3.313 13.5h-3c.648-4.193 1.512-8.265 2.563-12.375l.816-3.21L102 296Z",
    fill: "#E92734"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M547 369h1v25h-3l2-25Z",
    fill: "#DB393F"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M556 162h4v4h4v2h2v4h2v2c-3.162-1.431-5.623-3.175-8.25-5.438l-2.14-1.808C556 165 556 165 556 162Z",
    fill: "#D1DBD2"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M268 598h1a174.558 174.558 0 0 1 1 22h-2c-3.032-6.064-.777-15.48 0-22Z",
    fill: "#DC3643"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M263 454h1c.277 1.913.52 3.83.75 5.75l.422 3.234C265 466 265 466 263.016 468.391c-.666.53-1.33 1.062-2.016 1.609l-3-1 1.375-3c1.692-3.921 2.676-7.84 3.625-12Z",
    fill: "#E81B39"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M95 392h1c1.33 7.975 1.088 15.942 1 24h-1c-1.497-7.66-2.631-15.177-2-23l1-1Z",
    fill: "#EF1F30"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M578 185h8v7l-2 1c-4.875-4.625-4.875-4.625-6-8Z",
    fill: "#F2F4F6"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M548 154c2-.043 4-.04 6 0 1 1 1 1 1.063 4.563L555 162c-2.954-1.372-5.44-2.989-8-5l1-3Z",
    fill: "#F0F1F0"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M480 394h2c-.453 2.376-.913 4.75-1.375 7.125l-.383 2.016c-.8 4.078-1.84 7.948-3.242 11.859h-2v-5h2v-6h2l-.035-1.934-.027-2.503-.036-2.497C479 395 479 395 480 394Z",
    fill: "#E31F36"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M185 580c3.788.526 6.172 1.381 9 4v2c-6.152.098-6.152.098-8 0-1-1-1-1-1.063-3.563L185 580Z",
    fill: "#F1EFF3"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M345 94v1h-7v2c-6.688.624-13.281 1.13-20 1v-1c2.811-.51 5.623-1.008 8.438-1.5l2.373-.434c5.474-.946 10.634-1.2 16.189-1.066Z",
    fill: "#E12A3B"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M431 474c-3.472 3.472-8.415 4.448-13 6l-2.14.738c-3.401 1.087-5.472 1.28-8.86.262 18.35-7.547 18.35-7.547 24-7Z",
    fill: "#DF3044"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M202 406c2.144 3.216 3.66 6.531 5.188 10.063l.865 1.931c.711 1.643 1.336 3.323 1.947 5.006l-1 2c-4.397-3.487-5.764-7.7-7-13-.188-3.563-.188-3.563 0-6Z",
    fill: "#E62B3F"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M641 416h2c-.436 6.89-1.084 13.358-3 20l-2-2c.543-6.087.543-6.087 2-9 .225-1.537.408-3.08.563-4.625l.253-2.477L641 416Z",
    fill: "#EA1A31"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M645 397h1c.295 6.497-.827 12.622-2 19-2-2-2-2-2.047-5.152l.297-3.786.266-3.777C643 400 643 400 645 397Z",
    fill: "#F11930"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M647 314h1c.185 16.893.185 16.893-1 24h-2v-12h1l1-12Z",
    fill: "#F6E8E7"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "m562 566 4 1a679.453 679.453 0 0 1-3.875 4l-2.18 2.25C558 575 558 575 556 575v-5h2v-2h4v-2Z",
    fill: "#E51D32"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "m411 195 1 3-20-2v-1c6.449-1.32 12.488-.695 19 0Z",
    fill: "#E72136"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "m574 554 3 1-10 11-1-4h2v-4l2.438-.875c2.695-.858 2.695-.858 3.562-3.125Z",
    fill: "#E2202F"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M224 262h3c-1.764 3.751-3.939 7.235-6.125 10.75l-1.129 1.824c-.914 1.476-1.83 2.951-2.746 4.426-.71-1.684-.71-1.684-1-4 1.398-2.473 1.398-2.473 3.375-5.063 2.801-3.704 2.801-3.704 4.625-7.937Z",
    fill: "#E1203B"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M112 472h3l1 6h2c1.158 3.473 1.069 6.36 1 10-2.713-3.203-3.93-6.263-5.188-10.25l-1.042-3.266L112 472Z",
    fill: "#E62233"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M249 334h1c.113 6.11-.104 11.952-1 18h-3c.483-6.205 1.333-12 3-18Z",
    fill: "#DD373D"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "m337 510 2 2c-.375 3.125-.375 3.125-1 6h2l-1 3-5 1 3-12Z",
    fill: "#E22338"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M265 424c2.438.813 2.438.813 5 2 1.085 3.255 1.213 5.59 1 9l-2 3a177.118 177.118 0 0 0-2 4l.07-2.922.055-3.828.07-3.797c-.18-3.181-.505-4.818-2.195-7.453Z",
    fill: "#E72D43"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "m262 296 4 1a1735.407 1735.407 0 0 1-3.438 6l-1.933 3.375L259 309h-1v-7h2v-2h2v-4Z",
    fill: "#F1EBED"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M411 250c3.558.61 6.683 1.578 10 3v1h-5v2h-2v-2h-6v-2h3v-2Z",
    fill: "#E11630"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M440 638c-4.948 2.886-10.332 4-16 4l1-3c4.929-2.034 9.849-2.32 15-1Z",
    fill: "#E42033"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "m293 627 3 1v7l-7 1c.645-3.485 2.101-6.028 4-9Z",
    fill: "#DF1E35"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M510 606h6c-3.45 2.832-7.26 4.745-11.25 6.688l-1.969.97A1408.42 1408.42 0 0 1 498 616c1.22-3.66 2.126-3.923 5.438-5.688l2.433-1.324C508 608 508 608 510 608v-2Z",
    fill: "#E22234"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M323 563h1c1.375 5.498.797 8.385-1.797 13.398C321 578 321 578 318 579l.586-1.723c1.595-4.73 3.083-9.465 4.414-14.277Z",
    fill: "#E1263D"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M364 516h8v2h4l1 4c-9.595-2.89-9.595-2.89-13-6Z",
    fill: "#EDDDDF"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M645 404c2.28 3.42 2.22 4.682 2.125 8.688l-.055 3.011L647 418h-2c-1.87-3.74-1.306-8.468-.5-12.5l.5-1.5Z",
    fill: "#D2C6C4"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "m276 219 2 1-3 3-1.563 1.688C272 226 272 226 270 226v2h-6a37.474 37.474 0 0 1 12-9Z",
    fill: "#F2E5E1"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M435 641h-3v3h-16v-1c2.415-.532 4.831-1.05 7.25-1.563l2.066-.458c3.502-.731 6.287-1.301 9.684.021Z",
    fill: "#DDC2C3"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M270 622h1v7c-1.627-.45-3.252-.91-4.875-1.375l-2.742-.773C261 626 261 626 259 624c7.429-.286 7.429-.286 11 2v-4Z",
    fill: "#DB344A"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M379 354h1c.369 12.67.369 12.67-2 18l-2-1 .402-2.195c.9-4.93 1.796-9.858 2.598-14.805Z",
    fill: "#DF3447"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M636 292c3.558 3.558 3.952 8.647 4.125 13.5L640 308h-2c-1.19-5.38-2.292-10.453-2-16Z",
    fill: "#E63241"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M272 536h2c-.857 8.571-.857 8.571-3 12-1.114-2.229-1.165-3.53-1.188-6l-.042-2.125C270 538 270 538 272 536Z",
    fill: "#EA1D32"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M140 526c4.202 3.718 6.998 8.317 10 13l-4-1v-2h-2v-2h-2v-4l-2-1v-3Z",
    fill: "#D6CAC5"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "m262 116-6 2v2c-3.135 1.858-5.375 2.201-9 2 2.259-2.52 4.418-3.873 7.5-5.25l2.344-1.078C259 115 259 115 262 116Z",
    fill: "#D83746"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "m569 563 1 4c-2.188 2.813-2.188 2.813-5 5l-4-1 8-8Z",
    fill: "#F0ECF1"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M297 434c1.38 3.767.596 6.448-.438 10.25l-.87 3.266L295 450h-2l1-8h2l-.063-3.438C296 435 296 435 297 434Z",
    fill: "#DF3147"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M300 400c2.584 2.584 3.144 4.443 4 8-.123 2.741-.532 5.286-1 8h-2l.063-3.5c.007-4.244-.463-8.302-1.063-12.5Z",
    fill: "#E13345"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M376 318h3c2.393 4.188 3.55 7.153 3 12l-2 2-.875-3.625A116.588 116.588 0 0 0 376 318Z",
    fill: "#EB182E"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M534 288c3 1 3 1 4.75 4.313 1.58 4.663 1.58 4.663.25 7.687-3.338-3.641-3.979-7.286-5-12Z",
    fill: "#E9213B"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M117 255h1c.286 7.429.286 7.429-2 11h-2v2h-2a931.95 931.95 0 0 1 1.375-4.25l.773-2.39c.804-2.226 1.75-4.27 2.852-6.36Z",
    fill: "#DE2631"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M280 109c-5.395 3.085-9.79 4.556-16 5 2.22-2.22 3.985-3 6.875-4.188l2.617-1.105c2.673-.754 3.937-.646 6.508.293Z",
    fill: "#E22E3E"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "m363 412 2 2c-.2 5.3-1.381 8.148-5 12 .715-4.764 1.795-9.342 3-14Z",
    fill: "#E42E42"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M253 320h3c-.875 5.75-.875 5.75-2 8h-2l-1 3c-1-2-1-2-.441-4.164l.879-2.461.87-2.477L253 320Z",
    fill: "#E62D3A"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M133 225c1.017 2.655 1.13 3.692.004 6.36l-1.441 2.39-1.434 2.422L129 238h-3v-2h2l.25-1.563c1.071-3.482 2.885-6.309 4.75-9.437Z",
    fill: "#E7223E"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M428 100c5.789-.207 10.43.408 16 2-3.644 2.388-6.07 1.943-10.25 1.125l-3.266-.617L428 102v-2Z",
    fill: "#F31429"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M97 416h2c.389 1.956.76 3.915 1.125 5.875l.633 3.305L101 428l-2 2c-1.336-4.842-2.253-8.934-2-14Z",
    fill: "#E0222F"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M462 285c3.68 3.382 5.979 6.425 8 11h-3c-1.387-1.645-1.387-1.645-2.688-3.813l-1.324-2.144C462 288 462 288 462 285Z",
    fill: "#E0273F"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M398 247c1.626.114 3.25.242 4.875.375.905.07 1.81.14 2.742.21C408 248 408 248 410 250c-3.75 1.125-3.75 1.125-6 0v2h-2v-3l-4-2Z",
    fill: "#DF273F"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M616 497h1v11h-3v-2h2v-2l-4 2c1.199-3.083 2.477-6.063 4-9Z",
    fill: "#DCCAC7"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "m285 478 2 2c-.287 4.454-.594 8.151-3 12-1.335-5.34-.513-8.84 1-14Z",
    fill: "#E11D33"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M543 398h1c.204 5.738.271 10.605-2 16h-2l3-16Z",
    fill: "#DC343E"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M316 644h8v2l4 1c-1.625.027-3.25.046-4.875.063l-2.742.035C318 647 318 647 316 646v-2Z",
    fill: "#F2FBF9"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M510 612v2h-4v2c-2.375.625-2.375.625-5 1l-2-2c3.833-2.706 6.325-3.326 11-3Z",
    fill: "#D3CDCB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "m369 392 .375 1.938L370 396l2 1-2 3a75.316 75.316 0 0 0-1 5l-2-1c-.213-4.468.409-7.823 2-12Z",
    fill: "#DE3249"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "m522 138 11 7-2 2a348.275 348.275 0 0 1-4.5-2.813l-2.531-1.582L522 141v-3Z",
    fill: "#E12035"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M291 636c4.516-.077 8.59-.102 13 1v2l2 1c-5.135-.642-9.994-1.683-15-3v-1Z",
    fill: "#D84048"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "m248 468 10 2v2h-2l-1 2c-2.938-1.313-2.938-1.313-6-3l-1-3Z",
    fill: "#E03047"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M322 201v1c-4.658 1.205-9.236 2.285-14 3v-3c4.763-.953 9.167-1.083 14-1Z",
    fill: "#EA172A"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M581 192h3c1.605 1.969 1.605 1.969 3.188 4.5l1.605 2.531L590 201l-3 1-.813-1.813c-1.07-2.217-1.07-2.217-2.75-3.75C582 195 582 195 581 192Z",
    fill: "#E92435"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M212 598c5.63.402 8.004 2.29 12 6l-1 2a1562.107 1562.107 0 0 1-5.5-3.438l-3.094-1.933L212 599v-1Z",
    fill: "#E3243B"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M464 514h-2l-1 3-9 1c3.4-3.4 7.328-5.557 12-4Z",
    fill: "#DD374B"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M443 467a782.74 782.74 0 0 1-4.375 3l-2.46 1.688C434 473 434 473 432 473v-2l5-2v-2c3-1 3-1 6 0Z",
    fill: "#E1283E"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M626 263c2.458 3.687 3.012 6.697 4 11l-3-1c-2.28-6.158-2.28-6.158-1-10Z",
    fill: "#E22F49"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M317 256c-3.423 3.15-6.443 3.562-11 4 6.542-5.337 6.542-5.337 11-4Z",
    fill: "#DE2D3F"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "m155 186 1 2h4v2h-2l-.875 1.938C156 194 156 194 154 195l1-9Z",
    fill: "#D4D1CD"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "m311 593 2 2c-.375 3.625-.375 3.625-1 7h-2c-.81-2.915-1.218-4.461-.063-7.313L311 593Z",
    fill: "#DC1E39"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "m423.125 523.438 2.758.308L428 524v1c-4.053.982-7.839 1.082-12 1v-2c2.623-1.312 4.23-.896 7.125-.563Z",
    fill: "#EEE1E3"
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M218 438h2v2h2v2h2v2h2l-2 4a720348394.56 720348394.56 0 0 0-4.688-6.934C218 439 218 439 218 438Z",
    fill: "#F4EBEE"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M362 423c1.417 4.25.193 6.719-1 11h-2c-.37-6.4-.37-6.4 1.5-9.438L362 423Z",
    fill: "#E11530"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "m240 244 3 1-8 9-1-3c1.215-1.824 1.215-1.824 2.938-3.688l1.714-1.886L240 244Z",
    fill: "#DD1F38"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M128 230h2l-2 6h-2l-1 4c-1-3-1-3-1-6h2v-2h2v-2Z",
    fill: "#D2CFCF"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "m217 138 1 2h-2l-.563 1.875c-2.151 3.181-4.812 3.32-8.437 4.125 3.023-3.255 6.257-5.618 10-8Z",
    fill: "#DC2C41"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M510 130h8v5c-2.954-1.372-5.44-2.989-8-5Z",
    fill: "#F0E3E2"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "m306 101-2 3c-3 .313-3 .313-6 0l-2-2c6.286-2.429 6.286-2.429 10-1Z",
    fill: "#ED3742"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M204 592h6v2h2l-1 4a697.93 697.93 0 0 1-3.5-2.438l-1.969-1.37L204 593v-1Z",
    fill: "#DF1B2B"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "m158 550 4 3-1 2h-6v-3h3v-2Z",
    fill: "#F7F2F5"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "m616 494 2 1-5 9-2-1c1.09-3.775 1.908-6.47 5-9Z",
    fill: "#E11832"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M636 442h2l-3 12h-1c-.286-8.571-.286-8.571 2-12Z",
    fill: "#DB2633"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M539 416c1.804 2.76 2.013 3.89 1.625 7.25L540 426h-2c-.125-7.75-.125-7.75 1-10Z",
    fill: "#EB1528"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M111 269h1l-1 10-3 1c.551-3.95 1.39-7.35 3-11Z",
    fill: "#E0233A"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M306 260v2h2v2h-9c4.75-4 4.75-4 7-4Z",
    fill: "#E11E3C"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "m313 205-1 3h-10c7.286-4.857 7.286-4.857 11-3Z",
    fill: "#EDD7D8"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "m299 617 3 1v2h-3l-.813 2.375C297 625 297 625 294 627c1.335-3.594 2.96-6.755 5-10Z",
    fill: "#E02435"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M550 580h2v4h-2v2h-5l1-2h2v-2h2v-2Z",
    fill: "#D1CFCF"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M585 548h1v7h-7c1.375-1.5 1.375-1.5 3-3h2l1-4Z",
    fill: "#DFDEE1"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M277 512h1c.054 1.583.093 3.166.125 4.75l.07 2.672c-.204 2.692-.83 4.277-2.195 6.578v-4h-2v-2l2-1c.407-2.322.744-4.657 1-7Z",
    fill: "#DE1A2F"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M356 512c3.995 1.37 6.8 3.257 10 6-4.167-.473-6.929-1.047-10-4v-2Z",
    fill: "#DF243D"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M372 471c1.339.783 2.67 1.577 4 2.375l2.25 1.336L380 476v2c-3.937-1.312-6.227-2.92-9-6l1-1Z",
    fill: "#E12441"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M202 404h4v7h-2l-2-7Z",
    fill: "#F2F1F1"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "m375 373 2 1v5l-3 1c-.733 2.015-.733 2.015-1 4 .875-7.625.875-7.625 2-11Z",
    fill: "#D72B3E"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M213 280h2c-.783 3.916-2.392 7.364-4 11h-1c.468-4.056.88-7.466 3-11Z",
    fill: "#DB2339"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "m324 93 3.75-.125 2.11-.07C332 93 332 93 336 95l-11 1-1-3Z",
    fill: "#DBC7CA"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "m526 600-10 6c2.687-5.373 3.92-7.52 10-6Z",
    fill: "#E81F2E"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M124 498h2c2.296 2.561 3 3.48 3 7h2v3h-2l-5-10Z",
    fill: "#E51F34"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M263 454h1v10h-2l-1 2c1-8.571 1-8.571 2-12Z",
    fill: "#D02932"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M294 450c2.094 3.402 2.18 6.053 2 10h-2c-.75-3.663-1.238-6.424 0-10Z",
    fill: "#F0E3E4"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M103 444h2l.438 2.313c.525 2.769.525 2.769 1.562 5.687l-2 3c-1.193-3.877-2-6.916-2-11Z",
    fill: "#D33C48"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "m533 424 3 1-2 7-2-2c.375-3.125.375-3.125 1-6Z",
    fill: "#F5EDED"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M475 418h1v8l-4 2 3-10Z",
    fill: "#ECDBD9"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "m544 394 1 2h2c-.587 3.52-1.356 5.713-3 9v-11Z",
    fill: "#F91533"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M197 386h1c2.277 8.036 2.277 8.036 1 12h-2v-12Z",
    fill: "#EB3E4D"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M279 280c0 3.615-.892 5.112-3 8h-3c1.443-3.366 3.333-5.51 6-8Z",
    fill: "#DC2233"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M630 274c2.952 2.952 3.087 5.955 4 10h-2l-1 2-1-12Z",
    fill: "#DE3649"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M414 250h8l1 4-9-3v-1Z",
    fill: "#F1E4DB"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "m487 230 6 2v2l3 1-1 3a1154.753 1154.753 0 0 1-4-3.438l-2.25-1.933L487 231v-1Z",
    fill: "#DE2E43"
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "m169 178 1 3c-1.404 2.264-3.197 4.02-5 6l-2-2 6-7Z",
    fill: "#DE2A3D"
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M314 98v2h4v2c-3.719-.507-6.735-1.116-10-3 2-1 2-1 6-1Z",
    fill: "#DA3042"
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "m324 644 12 1v1c-8.571 1.286-8.571 1.286-12 0v-2Z",
    fill: "#F1E0DF"
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "m463 629 3 2-10 3v-3c3.313-1.125 3.313-1.125 7-2Z",
    fill: "#DC374C"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "m237 614 4 2v1h-13v-1l6.152-.684c1.86-.135 1.86-.135 2.848-1.316Z",
    fill: "#F0EDEA"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M195 586c2.884 1.293 4.872 2.66 7 5l-4 1v-2h-2l-1-4Z",
    fill: "#D4D0C9"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M164 556a90.488 90.488 0 0 1 4 4v2h-6l2-6Z",
    fill: "#DDD0D0"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M301 334c1.124 3.304.896 5.05-.438 8.25l-.87 2.14L299 346h-1c.115-1.438.242-2.876.375-4.313.07-.8.14-1.6.21-2.425C299 337 299 337 301 334Z",
    fill: "#DC2831"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M354 302c7.508-.37 7.508-.37 10 1.5l1 1.5c-2 1-2 1-4.164.441l-2.461-.878-2.477-.872L354 303v-1Z",
    fill: "#D73A4F"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M537 297c1.945 2.918 2.453 4.625 3 8l-4-1c-.043-2-.04-4 0-6l1-1Z",
    fill: "#EEEBEB"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M434 260c6.875 3.625 6.875 3.625 8 7-2.438-.813-2.438-.813-5-2l-1-3h-2v-2Z",
    fill: "#E0253E"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "m249 236 3 1-8 6c1.25-3.653 1.671-4.78 5-7Z",
    fill: "#E0243A"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "m237 126 1 3h-4v2l-4 2-2-2 9-5Z",
    fill: "#E42437"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "m416 97 10 1c-4.532 2.266-6.178 1.927-11 1l1-2Z",
    fill: "#DD232F"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "m307 92 4 1h-2v3h4v2l-5 1-1-7Z",
    fill: "#DDE5E3"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "m400 643 10 1v1l-10 1v-3Z",
    fill: "#D82F41"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M271 625h1v5l-4 2v-2h-2v-2l5 1v-4Z",
    fill: "#F5E5DF"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M326 552c1.43 2.354 2.087 3.48 1.625 6.25L327 560h-2l-1 2c.537-3.377 1.11-6.697 2-10Z",
    fill: "#EA3141"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "m452 518-1 3-9 1c2.747-2.747 6.086-4 10-4Z",
    fill: "#E1263B"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M281 496h2c.125 5.75.125 5.75-1 8h-2l1-8Z",
    fill: "#E42132"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M362 463c4.875 4.75 4.875 4.75 6 7h-4v-2h-2v-5Z",
    fill: "#EEE0DC"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M631 456h3l-2 10h-2l1-10Z",
    fill: "#E04B5C"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M463 443h1c.375 2.25.375 2.25 0 5-3 2.313-3 2.313-6 4a85.504 85.504 0 0 1 5-9Z",
    fill: "#F1E3E0"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M202 406c2.19 3.285 2.998 6.207 4 10l-3-1-1-9Z",
    fill: "#E0354D"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M252 328c1.456 4.52.27 7.516-1 12h-1a280.282 280.282 0 0 1-.125-4.313l-.07-2.425C250 331 250 331 252 328Z",
    fill: "#F2131F"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "m422 254 7 3c-3.196 1.065-5.657 1.074-9 1v-2h2v-2Z",
    fill: "#D8172E"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M423 254h7l1 4c-5.75-1.75-5.75-1.75-8-4Z",
    fill: "#F1D6D2"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "m121 247 2 3-2 4h-3c1.875-5.875 1.875-5.875 3-7Z",
    fill: "#DF2A3B"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M612 235c2.61 1.305 2.68 2.358 3.625 5.063.26.733.52 1.466.79 2.222.192.566.386 1.132.585 1.715h-2v-3h-2l-2-5 1-1Z",
    fill: "#E1324B"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M556 162h4v6c-2-1.313-2-1.313-4-3v-3Z",
    fill: "#D9C5C1"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M609 506h2c-1.75 5.75-1.75 5.75-4 8l-1-4h2l1-4Z",
    fill: "#E91E2E"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M377 321c2.125 3.188 2.502 5.265 3 9l-2-4h-2l1-5Z",
    fill: "#E2D3D3"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "m207 292 3 1-3 7-2-3c.875-2.688.875-2.688 2-5Z",
    fill: "#DE2C41"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "m211 288 3 2c-.813 1.938-.813 1.938-2 4l-3 1 2-7Z",
    fill: "#F5E4DE"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "m298 265-2 4h-2v2l-3-1c4.75-5 4.75-5 7-5Z",
    fill: "#DC2235"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M509 250c3.83 1.453 5.12 3.429 7 7l-2 1a966.825 966.825 0 0 1-2.5-3.438l-1.406-1.933C509 251 509 251 509 250Z",
    fill: "#E8263E"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "m462 213 5 1 1 4-7-3 1-2Z",
    fill: "#DD3445"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M588 201c2.622 1.049 3.794 1.65 5.25 4.125L594 207l-4-1v-2h-2v-3Z",
    fill: "#E71B22"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M532 138h2v6h-3l-1-3 2-3Z",
    fill: "#D1E0D9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPintrest);
export default __webpack_public_path__ + "static/media/Pintrest.19421685324e3f84ab231ffdbdbc4853.svg";
export { ForwardRef as ReactComponent };